import { isNil, omitBy } from 'lodash/fp';

export default (paginationQuery, searchQuery, order) =>
  omitBy(each => isNil(each) || each === '', {
    ...paginationQuery,
    ...(searchQuery || {}),
    order
  });
